module.exports = __webpack_public_path__ + "img/img-nenkin-teikibin-59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-nenkin-teikibin-59.png
// module id = b2kt
// module chunks = 1